const DateHelper = {
  formatDate(date) {
    let month = "" + (date.getMonth() + 1),
      day = "" + date.getDate(),
      year = date.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [day, month, year].join(".");
  },
  /**
   *
   * @param date {Date}
   * @returns {string}
   */
  formatTime(date) {
    let hours = "" + date.getHours(),
      minutes = "" + date.getMinutes(),
      seconds = "" + date.getSeconds();

    if (hours.length < 2) hours = "0" + hours;
    if (minutes.length < 2) minutes = "0" + minutes;
    if (seconds.length < 2) seconds = "0" + seconds;

    return [hours, minutes, seconds].join(":");
  }
};

export { DateHelper };
